import UpdateFormHead from "components/subHead/updateFromHead";
import {
  CREATE_ADDINF_FORM_ID_ROOM_ROOM,
  CREATE_BASE_FORM_ID_ROOM_ROOM,
  CREATE_IMG_FORM_ID_ROOM_ROOM,
} from "components/constent";
import { useTranslation } from "react-i18next";
import BaseInfForm from "../baseInfForm";
import { RoomImageProvider, useRoomAddInfContext } from "../context";
import RoomImg from "./roomImg";
import { useGetData } from "../service";
import useMultiLangStore from "store/multiLang";
import MultiFormHead from "components/subHead/multiFormHead";
import { useEditedLang, useSetBaseInf } from "./handles";
import MultilingualForm from "../multilingualForm";
import i18n from "locales/i18n";
import { ImagesProvider } from "../image/context";
import RoomImageManager from "../image";

export default function RoomCrate() {
  const { t } = useTranslation();
  const { getDefaultValue } = useRoomAddInfContext();

  const multiLang = useMultiLangStore((state) => state.multiLang);
  const { baseInf, addInf, imgList } = useGetData({ modalNm: "create" });
  const baseValue = getDefaultValue(multiLang) || {};

  const { setBasetInf } = useSetBaseInf();
  const { editedLang } = useEditedLang();
  const savedLangs =
    addInf.length !== 0 ? addInf.map((inf: any) => inf.langCd) : [];

  return (
    <>
      {/* 기본정보 등록 */}
      <UpdateFormHead
        title={t("row_ttl_default")}
        sub={t("sub_require")}
        formId={CREATE_BASE_FORM_ID_ROOM_ROOM}
        btnTxt={t("txt_create")}
        btnVisible={!baseInf?.rmNo}
      />
      {!baseInf && <BaseInfForm baseInf={null} formTyp={"create"} />}
      {baseInf && <BaseInfForm baseInf={baseInf} formTyp={"create"} />}

      {/* 추가정보 등록 */}
      {baseInf?.rmNo && (
        <>
          <MultiFormHead
            title={t("row_ttl_add_inf")}
            formId={CREATE_ADDINF_FORM_ID_ROOM_ROOM + "-" + multiLang}
            savedLangs={savedLangs}
            setBasetInf={setBasetInf}
            editedLang={editedLang}
          />
          <div>
            {addInf.length !== 0 && (
              <>
                {addInf.map((inf: any) => {
                  return (
                    <MultilingualForm
                      key={inf?.langCd}
                      inf={
                        inf.langCd === multiLang
                          ? {
                              ...inf,
                              ...baseValue,
                            }
                          : inf
                      }
                      updateAble="true"
                      formTyp={"read"}
                      formId={
                        CREATE_ADDINF_FORM_ID_ROOM_ROOM + "-" + inf?.langCd
                      }
                    />
                  );
                })}
              </>
            )}

            {/* Base i18n.language 언어폼  */}
            {!multiLang && savedLangs.length === 0 && (
              <MultilingualForm
                inf={{
                  langCd: i18n.language,
                  ...baseValue,
                }}
                formTyp={"create"}
                formId={CREATE_ADDINF_FORM_ID_ROOM_ROOM + "-" + multiLang}
              />
            )}
            {/* 언어버튼 클릭 시 폼 추가 */}
            {!!multiLang && !savedLangs.includes(multiLang) && (
              <MultilingualForm
                inf={{
                  langCd: multiLang,
                  ...baseValue,
                }}
                formTyp={"create"}
                formId={CREATE_ADDINF_FORM_ID_ROOM_ROOM + "-" + multiLang}
              />
            )}
          </div>
        </>
      )}

      {/* 이미지 등록 */}
      {baseInf?.rmNo && (
        <ImagesProvider>
          <RoomImageManager
            initialImages={imgList}
            rmNo={baseInf?.rmNo || null}
            formId={CREATE_IMG_FORM_ID_ROOM_ROOM}
            btnTxt={"등록"}
          />
        </ImagesProvider>
      )}
      {/* {baseInf?.rmNo && (
        <RoomImageProvider>
          {imgList.length === 0 && <RoomImg imgList={undefined} />}
          {imgList.length !== 0 && <RoomImg imgList={imgList} />}
        </RoomImageProvider>
      )} */}
    </>
  );
}
